import { EVM } from '../../utils/chains/evm/index';
export class Multichain {
    constructor(baseUrl, walletType) {
        this.chains = {};
        this.walletType = walletType;
        /** all on 1inch for swap */
        // this.chains.SEPOLIA = new EVM(11155111, 'https://rpc.sepolia.org');
        this.chains.MUMBAI = new EVM(baseUrl, 80001, 'https://polygon-mumbai.blockpi.network/v1/rpc/public', 'MUMBAI', walletType); // for DID
        this.chains.ETH = new EVM(baseUrl, 1, 'https://eth.llamarpc.com', 'ETH', walletType);
        this.chains.POLYGON = new EVM(baseUrl, 137, 'https://polygon.llamarpc.com', 'POLYGON', walletType);
        this.chains.AVALANCHE = new EVM(baseUrl, 43114, 'https://avalanche-c-chain.publicnode.com', 'AVALANCHE', walletType); // Avalanche C-chain
        this.chains.ARBITRUM = new EVM(baseUrl, 42161, 'https://arbitrum-one.publicnode.com', 'ARBITRUM', walletType); // Arbitrum One
        this.chains.BINANCE = new EVM(baseUrl, 56, 'https://bsc.publicnode.com', 'BINANCE', walletType);
        this.chains.OPTIMISM = new EVM(baseUrl, 10, 'https://optimism.meowrpc.com', 'OPTIMISM', walletType);
        // this.chains.KLAYTN = new EVM(8217, 'https://klaytn.blockpi.network/v1/rpc/public');
        this.chains.FANTOM = new EVM(baseUrl, 250, 'https://fantom.publicnode.com', 'FANTOM', walletType); // Fantom Opera
        // this.chains.GNOSIS = new EVM(
        //   baseUrl,
        //   100,
        //   'https://gnosis-mainnet.public.blastapi.io',
        //   'GNOSIS',
        //   walletType
        // );
        // /** */
        // this.chains.CELO = new EVM(baseUrl, 42220, 'https://rpc.ankr.com/celo', 'CELO', walletType); // not on 1inch for swap
        // this.chains.OKX = new EVM(baseUrl, 66, 'https://exchainrpc.okex.org', 'OKX', walletType); // OKX DEX
        this.chains.FUSE = new EVM(baseUrl, 122, 'https://rpc.fuse.io/', 'FUSE', walletType);
        this.chains.MANTA = new EVM(baseUrl, 169, 'https://1rpc.io/manta', 'MANTA', walletType);
        this.chains['MANTA-TESTNET'] = new EVM(baseUrl, 3441005, 'https://manta-testnet.calderachain.xyz/http', 'MANTA-TESTNET', walletType);
        this.chains.METIS = new EVM(baseUrl, 1099, 'https://metis-pokt.nodies.app', 'METIS', walletType);
        this.chains['METIS-TESTNET'] = new EVM(baseUrl, 599, 'https://goerli.gateway.metisdevops.link', 'METIS-TESTNET', walletType);
        this.chains.MANTLE = new EVM(baseUrl, 5000, 'https://rpc.mantle.xyz', 'MANTLE', walletType);
        this.chains['MANTLE-TESTNET'] = new EVM(baseUrl, 5001, 'https://rpc.testnet.mantle.xyz', 'MANTLE-TESTNET', walletType);
    }
}
